export const baseUrl = "https://sayartak.devoracompany.com/api";

export const loginURL = "v1/login";

export const workshopsURL = "v1/workshops";

export const tagsURL="v1/tags"

export const exportOrdersURL="v1/export/orders"

export const governoratesURL = "v1/governorates";

export const vehiclesURL = "v1/vehicles";

export const areasURL = "v1/areas";

export const advertisementsURL="v1/advertisements"

export const productsURL ="/v1/products"

export const usersURL = "v1/users";

export const ordersURL = "v1/orders";

export const discountTimestampRangeURL="/dashboard/discount-timestamp-range"

export const categoriesURL ="/dashboard/categories"

export const subCatURL="/dashboard/categories/get-subs"

export const privacyPolicyURL="/dashboard/privacy-policy"

export const discountCouponsURL="/dashboard/discount-coupons"

export const clientsURL = "clients/";

export const trainersURL = "trainers";

export const clientURL = "dashboard/clients";

export const employeesURL = "dashboard/employees";


export const permissionsURL = "permissions";

export const notificationsURL = "v1/notifications";


export const notificationsInfoURL="dashboard/info-notifications"

export const statisticsURL = "/dashboard/statistics";

export const departmentsURL = "departments";

export const contactUsURL = "contact-us";





export const storeInfoURL="/dashboard/store-info"





export const shippingSettingsURL ="dashboard/shipping-setting"



export const exportUsersURL="/export/users"

export const exportWorkshopssURL="/export/workshops"
